import React, { Component } from "react";
import PropTypes from "prop-types";
import ItemDiscussions from "./../list-item/ItemDiscussions";
import { withTranslation, Trans } from "react-i18next";
import List from "@material-ui/core/List";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import DiscussionEntries from "../discussions/DiscussionEntries";
import { Badge, Tabs, Tab, Tooltip } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { discussionClient } from "../../AxiosClient";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import CreateDiscussion from "../discussions/CreateDiscussion";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { withRouter } from "react-router";
import { Route } from "react-router-dom";
import { connect } from "react-redux";
import OpenInBrowserIcon from "@material-ui/icons/OpenInBrowser";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import { Typography } from "@material-ui/core";
import Icon from "@mdi/react";
const styles = (theme) => ({
  badge: {
    display: "flex",
    height: "50%",
  },
});
const StyledBadge = withStyles((theme) => ({
  badge: {
    right: -8,
    padding: '0 6px',
  },
}))(Badge);

export class SidebarDiscussions extends Component {
  static propTypes = {
    documentId: PropTypes.number.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      createDiscussionOpen: false,
      viewDiscussion: false,
      urls: [],
      index: 0,
      discussion: {},
      selectedDiscussions: 0,
      unreadExpert: 0,
      unreadPublic: 0,
    };
  }

  componentDidMount() {
    // this.getDocumentDiscussions(this.state.selectedDiscussions, () => {
    //   this.routerDiscussion();
    // });
    // this.getDiscussionSummary()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.discussionId !== this.props.discussionId) {
      this.routerDiscussion();
    }
    this.props.show === true && prevProps.show === false &&
        this.getDocumentDiscussions(this.state.selectedDiscussions, () => {
          this.routerDiscussion();
        });
    !prevProps.documentData.documentURL && 
      this.props.documentData.documentURL &&
        this.getDiscussionSummary()
  }

  routerDiscussion = () => {
    if (this.props.discussionId) {
      let discussion = this.state.urls.filter((item) => {
        return (
          item.discussionId === this.props.discussionId &&
          this.state.discussion.discussionId !== item.discussionId
        );
      });
      if (discussion.length === 1) {
        this.setState({ discussion: discussion[0] });
        discussionClient
          .get(`/discussion/${discussion[0].discussionId}/entry/`)
          .then((res) => {
            this.setState({
              discussionEntries: res.data.content,
              viewDiscussion: true,
              index: 1,
            });
          });
      }
    }
  };
  render() {
    const { classes, t } = this.props;
    let currentPath = this.props.match.url;
    let isExpert =
      this.props.user.userPermits.roles.beExpert ||
      this.props.user.userPermits.roles.administrator ||
      this.props.user.userPermits.roles.administrator.systemManager;

    let isInternal =
      this.props.documentData &&
      this.props.documentData.documentURL &&
      this.props.documentData.documentURL.includes("universal");
    return (
      <>
        {this.props.show && (
          <div
            style={{ display: "flex", flexDirection: "column", height: "100%" }}
          >
            <CardHeader
              titleTypographyProps={{ component: "h3" }}
              title={
                this.state.index == 1
                  ? this.state.discussion.title
                  : t("global_discussion_plural")
              }
              action={
                <>
                  {this.state.discussion.discussionId && (
                    <Tooltip title="Open in fullscreen view">
                      <IconButton
                        onClick={() =>
                          this.props.history.push({
                            pathname: `/full/discussion/${
                              this.state.discussion.discussionId
                            }`,
                          })
                        }
                      >
                        <OpenInBrowserIcon />
                      </IconButton>
                    </Tooltip>
                  )}
                  {this.state.index === 1 && (
                    <IconButton
                      onClick={this.showDiscussions}
                      aria-label="Back to discussion list"
                    >
                      <ArrowBackIcon />
                    </IconButton>
                  )}
                  <IconButton
                    onClick={this.closeSidebar}
                    aria-label={"Close sidebar"}
                  >
                    <CloseIcon />
                  </IconButton>
                </>
              }
            />
            {/* <CardContent style={{ height: "100%" }} id="two"> */}
            {this.state.index == 0 && (
              <CardContent style={{ flex: 1 }} id="discThree">
                {isExpert && (
                  <Tabs
                    value={this.state.selectedDiscussions}
                    onChange={(event, index) => {
                      this.setState({ selectedDiscussions: index });
                      this.getDocumentDiscussions(index);
                    }}
                  >
                    <Tab label={
                      <StyledBadge
                        color="secondary"
                        badgeContent={this.state.unreadPublic}
                      >
                        <Typography>{this.props.t("global_public") }</Typography>
                      </StyledBadge>}/>
                    <Tab label={
                      <StyledBadge
                        color="secondary"
                        badgeContent={this.state.unreadExpert}
                      >
                        <Typography>{this.props.t("global_expert") }</Typography>
                      </StyledBadge>}/>
                  </Tabs>
                )}
                <List id="discussions-list">
                  {this.state.urls.map((item, idx) => {
                    return (
                      // <Badge
                      //   className={classes.badge}
                      //   badgeContent={this.state.unreadDiscussions ? 1 : 0}
                      //   color="secondary"
                      // >
                      <ItemDiscussions
                        noMove
                        canModerate
                        noFullscreen
                        removeDiscussion={this.removeDiscussion}
                        key={item.discussionId}
                        discussionPortlet={false}
                        // onItemClick={(discussion) => this.setState({ index: 1, discussion })}
                        onItemClick={(discussion) => {
                          this.setState({ discussion, index: 1 });
                        }}
                        portlet={this.props.isPortlet}
                        fullscreen={this.props.fullscreen}
                        data={item}
                        refreshDiscussions={() => {
                            this.getDocumentDiscussions(
                              this.state.selectedDiscussions
                            )
                          }
                        }
                      />
                      // </Badge>
                    );
                  })}
                </List>
                {!this.state.urls ||
                  (this.state.urls.length === 0 && (
                    <div>{this.state.emptyMessage}</div>
                  ))}
              </CardContent>
            )}
            {this.state.index == 1 && (
              <div style={{ flex: 1 }}>
                <DiscussionEntries
                  openCreateContent={() =>
                    this.props.history.push({
                      pathname: `/full/discussion/${
                        this.state.discussion.discussionId
                      }`,
                      state: { createContent: true },
                    })
                  }
                  discussionId={this.state.discussion.discussionId}
                  noheader
                  updateDiscussion={(discussion) => {
                    this.setState({ discussion });
                  }}
                  showBackButton={true}
                  showDiscussions={this.showDiscussions}
                  discussion={this.state.discussion}
                  updateSummary={this.getDiscussionSummary}
                />
              </div>
            )}

            {this.state.index === 0 && (
              <div style={{ height: "100%" }}>
                <Fab
                  onClick={() => this.setState({ createDiscussionOpen: true })}
                  color="primary"
                  aria-label="New discussion"
                  style={{
                    position: "absolute",
                    bottom: 10,
                    right: 10,
                    zIndex: 9999999999,
                  }}
                >
                  <AddIcon />
                </Fab>
              </div>
            )}
          </div>
        )}
        {this.state.createDiscussionOpen && (
          <CreateDiscussion
            expert={this.state.selectedDiscussions}
            top={10}
            isInternal={isInternal}
            type={
              isInternal && this.state.selectedDiscussions ? "ki" : "document"
            }
            discussionOnId={
              this.state.selectedDiscussions === 1 && isInternal
                ? this.props.itemId
                : parseInt(this.props.documentId)
            }
            knowledgeSourceId={parseInt(this.props.knowledgeSourceId)}
            open={this.state.createDiscussionOpen}
            addedDiscussion={this.state.addedDiscussion}
            onDiscussionAdded={() =>
              this.getDocumentDiscussions(this.state.selectedDiscussions)
            }
            changeOpenCreateDiscussion={this.changeOpenCreateDiscussion}
          />
        )}
      </>
    );
  }
  // onEntryCreated = (entry) => {
  //   let array = this.state.discussionEntries.slice(0);
  //   array.push(entry);
  //   this.setState({ discussionEntries: array });
  // };
  removeDiscussion = (discussionId) => {
    let urls = this.state.urls.filter(
      (discussion) => discussion.discussionId !== discussionId
    );
    this.setState({ urls });
  };
  onDiscussionAdded = (discussion) => {
    let array = JSON.parse(JSON.stringify(this.state.urls)).slice(0);
    array.unshift(discussion);
    this.setState({ urls: array });
  };
  // changeOpenCreateEntry = () => {
  //   this.setState({
  //     createEntryOpen: !this.state.createEntryOpen,
  //   });
  // };
  showDiscussions = (event, value) => {
    this.getDocumentDiscussions(this.state.selectedDiscussions);
    this.setState({
      discussion: {},
      index: 0,
    });
  };
  closeSidebar = () => {
    this.setState({
      discussion: {},
      index: 0,
    });
    this.props.toggleSidebar();
  };
  showCreateDiscussion = () => {
    this.setState({
      index: 1,
    });
  };
  handleChangeIndex = (index) => {
    this.setState({
      index,
    });
  };
  showDiscussionList = () => {
    this.setState({
      viewDiscussion: !this.state.viewDiscussion,
    });
  };
  getDiscussionSummary = () => {
    let isInternal =
      this.props.documentData &&
      this.props.documentData.documentURL &&
      this.props.documentData.documentURL.includes("universal");
    let url =
      isInternal
        ? `/discussion/summary?type=KNOWLEDGE_ITEM&itemId=${this.props.itemId}`
        : `/discussion/summary?type=DOCUMENT&itemId=${this.props.documentId}`
    discussionClient.get(url).then((res) => {
      this.props.updateUnread && this.props.updateUnread(res.data ? res.data.unreadExpert + res.data.unreadPublic : 0)
      this.setState({unreadPublic: res.data.unreadPublic, unreadExpert: res.data.unreadExpert})
    });
  };
  getDocumentDiscussions = (expert, callback) => {
    let isInternal =
      this.props.documentData &&
      this.props.documentData.documentURL &&
      this.props.documentData.documentURL.includes("universal");
    let url =
      expert === 1 && isInternal
        ? `/discussion/?type=KNOWLEDGE_ITEM&itemId=${this.props.itemId}`
        : expert === 1 && !isInternal
          ? `/discussion/?type=DOCUMENT&itemId=${
              this.props.documentId
            }&expert=true`
          : `/discussion/?type=DOCUMENT&itemId=${this.props.documentId}`;
    discussionClient.get(url).then((res) => {
      // this.props.updateUnread && this.props.updateUnread(res.data.content ? res.data.content.filter(d => d.discussionRead === false).length : 0)
      this.setState({ urls: res.data.content }, () => callback && callback());
    });
  };

  changeOpenCreateDiscussion = () => {
    this.setState({
      createDiscussionOpen: false,
    });
  };
}
const mapStateToProps = (state) => ({
  user: state.user.currentUser,
});
export default connect(
  mapStateToProps,
  null
)(withRouter(withStyles(styles)(withTranslation()(SidebarDiscussions))));
